const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins
const { getOffsetTop, debounce } = window.BAO.Utils

class HotspotsScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    if (window.BAO.MediaBreakpoints.isSm) {
      this.updateEl()
      this.els.slides.element.setAttribute('data-keen-slider-disabled', '')
    } else {
      this.carousel = this.setupCarousel()
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      window,
      'resize',
      debounce(() => {
        if (window.BAO.MediaBreakpoints.isSm) {
          this.updateEl()
          this.els.slides.element.setAttribute('data-keen-slider-disabled', '')

          this.onScroll = this.onScroll.bind(this)
          window.addEventListener('scroll', this.onScroll, { passive: true })
        } else {
          this.carousel = this.setupCarousel()
        }
      }, 500),
    )

    this.onScroll = this.onScroll.bind(this)

    if (window.BAO.MediaBreakpoints.isSm) {
      window.addEventListener('scroll', this.onScroll, { passive: true })
    }

    this.els.card.elements.forEach((card) => {
      card.addEventListener('focusin', () => {
        this.animateTab(card)
      })
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.checkProgress()
  }

  animateTab (card) {
    const mediaElements = this.els.media.elements
    const cardElements = this.els.card.elements

    cardElements.forEach((itemEl) => {
      itemEl.classList.remove('sec-Hotspots_Item-active')
    })
    mediaElements.forEach((itemEl) => {
      itemEl.classList.remove('sec-Hotspots_Item-active')
    })
    card.classList.add('sec-Hotspots_Item-active')
    mediaElements
      .at(card.dataset.index)
      .classList.add('sec-Hotspots_Item-active')

    card.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    })
  }

  checkProgress () {
    if (!this.offsetHeight) return
    if (!window.BAO.MediaBreakpoints.isSm) return

    const elementHeight = this.els.cards.element.offsetHeight

    const windowTriggerPoint = window.innerHeight / 2

    const elementStartPoint =
      getOffsetTop(this.els.cards.element) - windowTriggerPoint
    const elementEndPoint = elementStartPoint + elementHeight

    if (
      this.lastKnownY <= elementStartPoint ||
      this.lastKnownY > elementEndPoint
    ) {
      return
    }

    this.els.card.elements.forEach((cardEl, index) => {
      const cardStartPoint = getOffsetTop(cardEl) - windowTriggerPoint
      const cardEndPoint = cardStartPoint + cardEl.offsetHeight

      const mediaElements = this.els.media.elements
      const cardElements = this.els.card.elements

      const isWithinRange =
        this.lastKnownY >= cardStartPoint && this.lastKnownY < cardEndPoint

      if (isWithinRange) {
        cardElements.forEach((itemEl) => {
          itemEl.classList.remove('sec-Hotspots_Item-active')
        })
        mediaElements.forEach((itemEl) => {
          itemEl.classList.remove('sec-Hotspots_Item-active')
        })
        cardEl.classList.add('sec-Hotspots_Item-active')
        mediaElements.at(index).classList.add('sec-Hotspots_Item-active')
      }
    })
  }

  setupCarousel () {
    if (!this.els.media?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.media.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
        detailsChanged: (s) => {
          s.slides.forEach((element, idx) => {
            if (idx === s.track.details.rel) {
              element.classList.add('sec-Hotspots_Item-active')
            } else {
              element.classList.remove('sec-Hotspots_Item-active')
            }
          })
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('hotspots-scroll')) {
  customElements.define('hotspots-scroll', HotspotsScroll)
}
